// @flow
import AudioRecorderActionTypes from '../action-types/audio-recorder';
import { initializeRecordingContext } from '../reducer-utils/audio-recorder';
import { RecordingContext } from '../types/audio-recorder';

export interface State {
  hasMicrophoneRestarted: boolean;
  isRestartingMicrophone: boolean;
  recordingContext: RecordingContext;
}

const initializeState = (): State => {
  return {
    hasMicrophoneRestarted: false,
    isRestartingMicrophone: false,
    recordingContext: initializeRecordingContext(),
  };
};

const INITIAL_STATE: State = initializeState();

const audioRecorderReducer = (state: State = INITIAL_STATE, action: any) => {
  switch (action.type) {
    case AudioRecorderActionTypes.RESET_AUDIO_RECORDER_STATE:
      return {
        ...state,
        ...initializeState(),
      };
    case AudioRecorderActionTypes.RESET_RECORDING_CONTEXT:
      return {
        ...state,
        recordingContext: initializeRecordingContext(),
      };
    case AudioRecorderActionTypes.SET_HAS_MICROPHONE_RESTARTED:
      return {
        ...state,
        hasMicrophoneRestarted: action.payload,
      };
    case AudioRecorderActionTypes.SET_IS_RESTARTING_MICROPHONE:
      return {
        ...state,
        isRestartingMicrophone: action.payload,
      };
    case AudioRecorderActionTypes.SET_RECORDING_CONTEXT:
      return {
        ...state,
        recordingContext: action.payload,
      };
    default:
      return state;
  }
};

export default audioRecorderReducer;
